export default __webpack_public_path__ + "static/media/detail-2.647baa0f.svg";